import apiClient from './api.ts';
import { GeneralExamInputSchema } from '@/types/general_exam_schema.ts';
import {
  ExamScoreGroupInputSchema,
  SubjectExamInputSchema,
  SubjectExamInputUpdateSchema
} from '@/types/subject_exam_schema.ts';

export default {
  async getAllGlobalExam(isActive: boolean, page: number = 1, limit: number = 20, type?: string, sort: string = 'created_at', order: 'asc' | 'desc' = 'desc') {
    const params = new URLSearchParams({
      is_active: isActive.toString(),
      page: page.toString(),
      limit: limit.toString(),
      sort,
      order
    });
    if (type) {
      params.append('period_type', type);
    }
    return await apiClient.get(`exams/global?${params}`);
  },
  async getAllSubjectExam(globalExamId: number, classId: number, isCompleted?: boolean) {
    const params = new URLSearchParams();
    if (typeof isCompleted === 'boolean') {
      params.append('isCompleted', isCompleted.toString());
    }
    const query = params.toString();
    return await apiClient.get(`exams/teacher/global/${globalExamId}/class/${classId}${query ? `?${query}` : ''}`);
  },
  async getScoreGroups(globalExamId: number, classId: number) {
    return await apiClient.get(`exams/score-groups/global/${globalExamId}/class/${classId}`);
  },
  async getScoreGroupsByClasses(classIds: number[], periodIds: number[] = []) {
    const parts: string[] = [];
    if (classIds.length) parts.push(`class_ids=${classIds.join(',')}`);
    if (periodIds.length) parts.push(`period_ids=${periodIds.join(',')}`);
    return await apiClient.get(`exams/score-groups${parts.length ? `?${parts.join('&')}` : ''}`);
  },
  async getSubjectExamById(id: number) {
    return await apiClient.get(`exams/${id}/teacher`)
  },
  async createGlobalExam(exam: GeneralExamInputSchema) {
    return await apiClient.post(`exams/global`, exam);
  },
  async createSubjectExam(exam: SubjectExamInputSchema) {
    return await apiClient.post(`exams/teacher`, exam);
  },
  async createScoreGroup(group: ExamScoreGroupInputSchema) {
    return await apiClient.post(`exams/score-groups`, group);
  },
  async updateGlobalExam(examId: number, exam: {
    name: string;
    start_date: string;
    end_date: string;
    reporting_period_id: number;
    description: string;
    allow_teacher_exams?: boolean;
    score_entry_mode?: string;
    scoring_enabled?: boolean;
  }) {
    return await apiClient.put(`exams/${examId}/global/update`, exam);
  },
  async updateSubjectExam(examId: number, exam: SubjectExamInputUpdateSchema) {
    return await apiClient.put(`exams/${examId}/teacher/update`, exam);
  },
  async deleteGlobalExam(examId: number) {
    return await apiClient.delete(`exams/${examId}/global`);
  },
  async archiveGlobalExam(examId: number) {
    return await apiClient.put(`exams/${examId}/global/archive`);
  },
  async unarchiveGlobalExam(examId: number) {
    return await apiClient.put(`exams/${examId}/global/unarchive`);
  },
  async markCompletedGlobalExam(examId: number) {
    return await apiClient.put(`exams/${examId}/global/completed`);
  },
  async markCompletedSubjectExam(examId: number) {
    return await apiClient.put(`exams/${examId}/teacher/completed`);
  },
  async archiveSubjectExam(examId: number) {
    return await apiClient.put(`exams/${examId}/teacher/archive`);
  },
  async getArchivedTeacherExams(page = 1, limit = 10) {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    return await apiClient.get(`exams/teacher/archived?${params}`);
  },
  async unarchiveTeacherExam(examId: number) {
    return await apiClient.put(`exams/${examId}/teacher/unarchive`);
  },
  async deleteTeacherExamPermanently(examId: number) {
    return await apiClient.delete(`exams/${examId}/teacher`);
  },
  async deleteScoreGroup(groupId: number) {
    return await apiClient.delete(`exams/score-groups/${groupId}`);
  }
};
